import Swal from 'sweetalert2'

const customSwalClass = {
    container: 'swal-z-index',
};

export const swalSuccessTimer = ({ title = ``, icon = 'success', timer = 1500, showConfirmButton = false, customClass = customSwalClass }) => {
  return Swal.fire({
    title: title,
    icon: icon,
    timer: timer,
    showConfirmButton: showConfirmButton,
    customClass: customClass,
  });
};

export const swalSuccessBtn = ({ title = ``, icon = 'success', confirmButtonColor = '#4FA893', confirmButtonText = 'ตกลง', customClass = customSwalClass }) => {
    return Swal.fire({
        title: title,
        icon: icon,
        confirmButtonColor: confirmButtonColor,
        confirmButtonText: confirmButtonText,
        customClass: customClass,
    });
};

export const swalErrorTimer = ({ title = 'เกิดข้อผิดพลาด', text = ``, timer = 1500, showConfirmButton = false, customClass = customSwalClass}) => {
    return Swal.fire({
        title: title,
        icon: 'error',
        text: text,
        timer: timer,
        showConfirmButton: showConfirmButton,
        customClass: customClass,
    });
};

export const swalErrorBtn = ({ title = ``, icon = 'error', confirmButtonColor = '#4FA893', confirmButtonText = 'ตกลง', customClass = customSwalClass }) => {
    return Swal.fire({
        title: title,
        icon: icon,
        confirmButtonColor: confirmButtonColor,
        confirmButtonText: confirmButtonText,
        customClass: customClass,
    });
};

export const swalLoading = ({title = ``, showConfirmButton = false, customClass = customSwalClass}) => {
    return Swal.fire({
        title: title,
        text: 'โปรดรอสักครู่...',
        showConfirmButton: showConfirmButton,
        didOpen: () => {
            Swal.showLoading();
        },
        customClass: customClass,
    });
};

export const swalLoadingTimer = ({ title = 'โปรดรอสักครู่..', text = ``, timer = 1500, showConfirmButton = false, customClass = customSwalClass}) => {
    return Swal.fire({
        title: title,
        text: text,
        timer: timer,
        showConfirmButton: showConfirmButton,
        customClass: customClass,
    });
};

export const swalConfirm = ({
    title = ``,
    icon = 'info',
    showDenyButton = true,
    confirmButtonColor = '#4FA893',
    confirmButtonText = 'ตกลง',
    denyButtonText = 'ยกเลิก',
    customClass = customSwalClass
}) => {
    return Swal.fire({
        title: title,
        icon: icon,
        showDenyButton: showDenyButton,
        confirmButtonColor: confirmButtonColor,
        confirmButtonText: confirmButtonText,
        denyButtonText: denyButtonText,
        customClass: customClass,
    });
};

export const swalConfirmEmail = ({
    title = ``,
    icon = 'info',
    html = ``,
    showDenyButton = true,
    confirmButtonColor = '#4FA893',
    confirmButtonText = 'ตกลง',
    denyButtonText = 'ยกเลิก',
    customClass = customSwalClass
}) => {
    return Swal.fire({
        title: title,
        icon: icon,
        html: html,
        showDenyButton: showDenyButton,
        confirmButtonColor: confirmButtonColor,
        confirmButtonText: confirmButtonText,
        denyButtonText: denyButtonText,
        customClass: customClass,
    });
};

export const swalConfirmAddText = ({
    title = ``,
    text = ``,
    icon = 'info',
    showDenyButton = true,
    confirmButtonColor = '#4FA893',
    confirmButtonText = 'ตกลง',
    denyButtonText = 'ยกเลิก',
    customClass = customSwalClass
}) => {
    return Swal.fire({
        title: title,
        text: text,
        icon: icon,
        showDenyButton: showDenyButton,
        confirmButtonColor: confirmButtonColor,
        confirmButtonText: confirmButtonText,
        denyButtonText: denyButtonText,
        customClass: customClass,
    });
};

export const swalShowProgress = (totalProgress, title, customClass) => {
  const html = `
    <style>
      .custom-progress {
        width: 100%;
        height: 20px;
        border-radius: 10px;
        overflow: hidden;
        appearance: none;
      }

      .custom-progress::-webkit-progress-bar {
        background-color: #eee;
        border-radius: 10px;
      }

      .custom-progress::-webkit-progress-value {
        background-color: #4FA893;
        border-radius: 10px;
      }

      .custom-progress::-moz-progress-bar {
        background-color: #4FA893;
        border-radius: 10px;
      }
    </style>
    <progress id="email-progress" value="0" max="${totalProgress || 0}" style="width: 100%" class="custom-progress"></progress>
    <div id="progress-text" style="margin-top: 10px">0 / ${totalProgress || 0}</div>
  `

  return Swal.fire({
    title: title || 'กำลังประมวล...',
    customClass: customClass || customSwalClass,
    html,
    allowOutsideClick: false,
    showConfirmButton: false,
    didOpen: () => {
      Swal.showLoading()
    }
  })
}

export const swalClose = () => Swal.close()
